// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aj79","questions":"styles_questions__3tMQU","footer":"styles_footer__2abEW"};